export const PWA_BASE=(process.env.REACT_APP_CUSTOMER_PORTAL_URL||'https://ao-my-ao-pwa.pages.dev').replace(/\/$/,'');
export const pwa=(route)=>`${PWA_BASE}/${route.startsWith('#')?route:`#${route}`}`;

const defaults={
  care_collection:true,ao_standard:true,care_journey:true,atelier_visit:true,
  branch_directions:true,branch_call:true,whatsapp:false,track_order:true,my_ao:true,
  membership:false,offers:true,feedback:true,support:true,supporting_photos:false
};
function bool(v,fallback){if(typeof v==='boolean')return v;if(v&&typeof v==='object'){for(const k of ['visible','is_visible','is_customer_visible','enabled','is_enabled','effective_visible'])if(typeof v[k]==='boolean')return v[k];}return fallback;}
export function normalizeVisibility(data){
  const raw=data?.customer_visibility||data?.presentation?.customer_visibility||data?.visibility||{};
  const out={...defaults};
  if(Array.isArray(raw)) raw.forEach((x)=>{const k=x?.feature_code||x?.placement_code||x?.code||x?.key;if(k&&k in out)out[k]=bool(x,out[k]);});
  else if(raw&&typeof raw==='object') Object.keys(out).forEach(k=>{if(Object.prototype.hasOwnProperty.call(raw,k))out[k]=bool(raw[k],out[k]);});
  const portal=data?.customer_portal_features||data?.presentation?.customer_portal_features;
  if(Array.isArray(portal)) portal.forEach(x=>{const k=x?.feature_code||x?.code;if(k&&k in out && ['membership','offers','feedback','support','supporting_photos'].includes(k)) out[k]=out[k]&&bool(x,false);});
  return out;
}
